import React from 'react';
import { parseUnits } from 'viem';

import type { Address } from 'types/api/address';

import config from 'configs/app';
import { ethToHaqq } from 'lib/haqq/convert-address';
import { useIndexerBalanceQuery } from 'lib/haqq/use-indexer-balance-query';
import { currencyUnits } from 'lib/units';
import CurrencyValue from 'ui/shared/CurrencyValue';
import * as DetailsInfoItem from 'ui/shared/DetailsInfoItem';
import NativeTokenIcon from 'ui/shared/NativeTokenIcon';

interface Props {
  data: Pick<Address, 'block_number_balance_updated_at' | 'coin_balance' | 'hash' | 'exchange_rate'>;
  isLoading: boolean;
}

const AddressBalance = ({ data }: Props) => {
  const bech32Address = data?.hash ? ethToHaqq(data?.hash) : undefined;
  const { data: indexerBalances, isLoading: isIndexerBalancesLoading } = useIndexerBalanceQuery(bech32Address, true);

  return (
    <>
      <DetailsInfoItem.Label
        hint={ `${ currencyUnits.ether } balance` }
        isLoading={ isIndexerBalancesLoading }
      >
        Total balance
      </DetailsInfoItem.Label>
      <DetailsInfoItem.Value alignSelf="center" flexWrap="nowrap">
        <NativeTokenIcon boxSize={ 6 } mr={ 2 } isLoading={ isIndexerBalancesLoading }/>
        <CurrencyValue
          value={ parseUnits(indexerBalances?.total.toString() || '0', config.chain.currency.decimals) }
          exchangeRate={ data.exchange_rate }
          decimals={ String(config.chain.currency.decimals) }
          currency={ currencyUnits.ether }
          accuracyUsd={ 2 }
          accuracy={ 8 }
          flexWrap="wrap"
          isLoading={ isIndexerBalancesLoading }
        />
      </DetailsInfoItem.Value>
    </>
  );
};

export default React.memo(AddressBalance);
